import React, { Component } from "react";
import MainBanner from "./MainBanner";

import Review from "./Review";


//Define Default Content
class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    return (
       <div>

           {/* Start Preloader Area */}

           {/* End Preloader Area */}


           {/*---------Start Imported All Sections-----------*/}
            <MainBanner/><br/>

             <Review/>

           {/*---------End Imported All Sections-----------*/}
       </div>
    );
  }
}

export default HomePage;
